import { Link, LinkProps } from 'react-router-dom'
import { BackArrow } from 'components/Icons'
import styles from './router.module.scss'
import { ReactNode } from 'react'
import classNames from 'classnames'
import { Props as BtnPrimaryProps } from 'components/generic/BtnPrimary'

interface Props {
  to: LinkProps['to']
  children: ReactNode
  className?: string
}

interface RouterLinkProps extends Props {
  type?: 'link' | 'backLink'
}

export const RouterLink = ({ children, to, className = '', type = 'link' }: RouterLinkProps) => {
  return (
    <Link className={classNames(className, styles[type])} to={to}>
      {type === 'backLink' && <BackArrow aria-hidden />} {children}
    </Link>
  )
}

interface RouterBtnProps extends Props {
  type?: 'btnPrimary' | 'btnSecondary'
  size?: BtnPrimaryProps['size']
  fullWidthAtMobile?: boolean
}

export const RouterBtn = ({
  children,
  to,
  className = '',
  type = 'btnPrimary',
  size = 'medium',
  fullWidthAtMobile = false,
}: RouterBtnProps) => {
  return (
    <Link
      className={classNames(styles.btn, className, styles[size], {
        [styles.primaryBtn]: type === 'btnPrimary',
        [styles.secondaryBtn]: type === 'btnSecondary',
        [styles.fullWidthAtMobile]: fullWidthAtMobile,
      })}
      to={to}
    >
      {children}
    </Link>
  )
}
